import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  z-index: 500;
  pointer-events: none;
  padding: 0 20px;
`;

const WarningMessage = styled.div`
  max-width: 80%;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 15px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

interface NetworkInformation extends EventTarget {
  effectiveType?: "slow-2g" | "2g" | "3g" | "4g";
  downlink?: number;
  rtt?: number;
  addEventListener: (
    type: string,
    listener: EventListenerOrEventListenerObject
  ) => void;
  removeEventListener: (
    type: string,
    listener: EventListenerOrEventListenerObject
  ) => void;
}

const WeakNetworkPopup: React.FC = () => {
  const [isWeakNetwork, setIsWeakNetwork] = useState<boolean>(false);
  const [showWarning, setShowWarning] = useState<boolean>(false);

  useEffect(() => {
    const connection = (navigator as any).connection as NetworkInformation;

    const checkNetworkQuality = () => {
      if (connection) {
        const { effectiveType, downlink = 0, rtt = 0 } = connection;

        if (
          ["2g", "slow-2g"].includes(effectiveType || "") ||
          downlink < 1.5 ||
          rtt > 300
        ) {
          setIsWeakNetwork(true);
        } else {
          setIsWeakNetwork(false);
        }
      }
    };

    checkNetworkQuality();

    if (connection) {
      connection.addEventListener?.("change", checkNetworkQuality);
    }

    return () => {
      connection?.removeEventListener?.("change", checkNetworkQuality);
    };
  }, []);

  useEffect(() => {
    let timer: number;
    if (isWeakNetwork) {
      timer = window.setTimeout(() => {
        setShowWarning(true);
      }, 2000);
    } else {
      setShowWarning(false);
    }
    
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isWeakNetwork]);

  useEffect(() => {
    let hideTimer: number;
    if (showWarning) {
      hideTimer = window.setTimeout(() => {
        setShowWarning(false);
      }, 5000);
    }
    
    return () => {
      if (hideTimer) clearTimeout(hideTimer);
    };
  }, [showWarning]);

  return (
    <>
      {showWarning && (
        <Overlay>
          <WarningMessage>
            ⚠️ Weak Network Detected. Please check your connection.
          </WarningMessage>
        </Overlay>
      )}
    </>
  );
};

export default WeakNetworkPopup;
